import Axios, { AxiosResponse } from "axios"
import {
  GroupMemberQueryState,
  GroupMemberResponse,
  GroupsOrganizationForm,
  GroupsOrganizationProjectResponse,
  GroupsOrganizationQueryState,
  GroupsOrganizationResponse,
  GroupsOrganizationRoleResponse,
} from "./groups.type"

export const getGroupsOrganizationMiddleware = async (
  params?: GroupsOrganizationQueryState
) => {
  try {
    const response: AxiosResponse<{
      data: GroupsOrganizationResponse[]
      total: number
    }> = await Axios.get(`/api/group-organization/get-list`, {
      params,
    })
    return {
      data: response.data.data,
      total: response.data.total,
    }
  } catch (error) {
    return {
      data: [],
      total: 0,
    }
  }
}

export const getGroupsOrganizationDetailMiddleware = async (
  groupOrganizationId: string
) => {
  try {
    const response: AxiosResponse<{
      data: GroupsOrganizationResponse
    }> = await Axios.get(`/api/group-organization/${groupOrganizationId}`)
    return response.data.data
  } catch (error) {
    return null
  }
}

export const postGroupsOrganizationMiddleware = async (
  dataRequest: GroupsOrganizationForm
) => {
  const response: AxiosResponse<{
    data: GroupsOrganizationResponse | null
  }> = await Axios.post(`/api/group-organization/create`, dataRequest)
  return response.data.data
}

export const putGroupsOrganizationMiddleware = async (
  groupOrganizationId: string,
  dataRequest: GroupsOrganizationForm
) => {
  const response: AxiosResponse<{
    data: GroupsOrganizationResponse | null
  }> = await Axios.put(
    `/api/group-organization/${groupOrganizationId}/update`,
    dataRequest
  )
  return response.data.data
}

export const postAssignProjectToGroupsOrganizationMiddleware =
  async (dataRequest: {
    project_id: string
    group_organization_id?: string
    user_id?: string
  }) => {
    const response: AxiosResponse<{
      data: {
        groupOrganization: {
          id: string
          name: string
          code: string
        }
      }
    }> = await Axios.post(
      `/api/group-organization/add-project?loading=0`,
      dataRequest
    )
    return response.data.data
  }

export const postUnassignProjectFromGroupsOrganizationMiddleware = async (
  groupProjectId: string
) => {
  const response = await Axios.post(`/api/group-organization/remove-project`, {
    group_project_id: groupProjectId,
  })
  return response.data.data
}

export const postAssignMemberToGroupsOrganizationMiddleware =
  async (dataRequest: { group_organization_id: string; users: string }) => {
    const response = await Axios.post(
      `/api/group-organization/add-member?loading=0`,
      dataRequest
    )
    return response.data.data
  }

export const getUserAddGroupsOrganizationMiddleware = async (
  groupOrganizationId: string
) => {
  try {
    const response: AxiosResponse<{
      data: {
        id: string
        fullname: string
        email: string
        role_name: string
      }[]
    }> = await Axios.get(`/api/user/${groupOrganizationId}/add-group`)
    return response.data.data
  } catch (error) {
    return []
  }
}

export const postUnassignMemberFromGroupsOrganizationMiddleware =
  async (dataRequest: { user_id: string; group_organization_id: string }) => {
    const response = await Axios.post(
      `/api/group-organization/remove-member`,
      dataRequest
    )
    return response.data.data
  }

export const getGroupsOrganizationRolesMiddleware = async () => {
  try {
    const response: AxiosResponse<{
      data: GroupsOrganizationRoleResponse[]
    }> = await Axios.get(`/api/group-organization/get-roles`)
    return {
      data: response.data.data,
    }
  } catch (error) {
    return {
      data: [],
    }
  }
}

export const getAllGroupMemberMiddleware = async (
  groupId: string,
  params: GroupMemberQueryState
) => {
  try {
    const response: AxiosResponse<{
      data: GroupMemberResponse[]
      total: number
    }> = await Axios.get(`/api/group-organization/${groupId}/members`, {
      params,
    })
    return {
      data: response.data.data,
      total: response.data.total,
    }
  } catch (error) {
    return {
      data: [],
      total: 0,
    }
  }
}

export const postChangeRoleMemberGroupsOrganizationMiddleware =
  async (dataRequest: {
    group_organization_id: string
    user_id: string
    role_id: string
  }) => {
    const response = await Axios.post(
      `/api/group-organization/change-role`,
      dataRequest
    )
    return response.data.data
  }

export const getGroupsOrganizationProjectMiddleware = async (projectId) => {
  try {
    const response: AxiosResponse<{
      data: GroupsOrganizationProjectResponse
    }> = await Axios.get(`/api/group-organization/project/${projectId}`)
    return response.data.data
  } catch (error) {
    return {
      projectId: "",
      projectName: "",
      projectCode: "",
      groupOrganizations: [],
      projectKey: "",
      projectKeyType: "",
    }
  }
}

export const deleteGroupsOrganizationMiddleware = async (
  groupOrganizationId: string
) => {
  const response: AxiosResponse<{
    data: GroupsOrganizationResponse | null
  }> = await Axios.delete(
    `/api/group-organization/${groupOrganizationId}/delete`
  )
  return response.data.data
}
